


import React,{useRef} from "react";
import { Box, Avatar, useTheme,IconButton,Menu,MenuItem } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import BaseCard from "../../../components/Cards/Card";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import DocumentUpload from "../../../components/DocumentUpload";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { toast, Toaster } from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import { BASE_URL } from "../../../components/BaseUrl";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import AddIcon from "@mui/icons-material/Add"; // MUI plus icon
import { getProfileDraft, setProfileDraft } from "./ProfileDraft";
import Webcam from "react-webcam";
import dummy from "../../../assets/dummy.png";
import imageicon from "../../../assets/imageicon.png";
import document1 from '../../../assets/document1.svg';
import { apiPost, apiFetch } from "../../../utils/apiService";
const CreateProfile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const profileUpdateToken =
    useSelector((s) => s.auth.profileUpdateToken) ||
    localStorage.getItem("profileUpdateToken");

  // Avatar state (same pattern as your AddCompanyDrawer)
  const [imageFile, setImageFile] = React.useState(null);
  const [uploadedAvatarUrl, setUploadedAvatarUrl] = React.useState(""); // URL returned from server
  const [saving, setSaving] = React.useState(false);
  const [uploadingDoc, setUploadingDoc] = React.useState(false);
  const [docFileName, setDocFileName] = React.useState("");

const [anchorEl, setAnchorEl] = React.useState(null);
const openOptions = Boolean(anchorEl);
const [cameraTarget, setCameraTarget] = React.useState("avatar");
const handleOpenOptions = (e) => setAnchorEl(e.currentTarget);
const handleCloseOptions = () => setAnchorEl(null);

const handleSelectCamera = () => {
  setAnchorEl(null);
  openCamera();
};

const handleSelectGallery = () => {
  setAnchorEl(null);
  handlePickFile();
};
const fileInputRef = React.useRef(null);
const [uploading, setUploading] = React.useState(false);
const [avatarPreview, setAvatarPreview] = React.useState(""); // holds URL (not base64)

const handlePickFile = () => fileInputRef.current?.click();

// Upload to server and normalize URL
const uploadImageToServer = async (file) => {
  const form = new FormData();
  form.append("image", file);

  const res = await fetch(`${BASE_URL}/upload/image`, {
    method: "POST",
    body: form,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Upload failed");

  // Prefer data.data.url, fallback to url/path
let imageUrl = data?.data?.url || data?.url || data?.path || "";
console.log("image url is",imageUrl)
// If it's a relative path, prepend BASE_URL + "/api"
if (imageUrl && !imageUrl.startsWith("http")) {
  // Ensure correct slash
  if (!imageUrl.startsWith("/")) imageUrl = `/${imageUrl}`;
  imageUrl = `${BASE_URL}/api${imageUrl}`;
}

// Some backends return duplicated "/api/api"
imageUrl = imageUrl.replace("/api/api", "/api");

console.log("✅ Normalized uploaded image URL:", imageUrl);
return imageUrl;
};

// Upload handler — sets URL into Formik + preview
const handleFileChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  try {
    setUploading(true);
    const uploadedUrl = await uploadImageToServer(file);
    console.log(uploadedUrl)
    setAvatarPreview(uploadedUrl);
    formik.setFieldValue("avatar", uploadedUrl);
  } catch (err) {
    console.error(err);
    setAvatarPreview("dummy");
    formik.setFieldValue("avatar", "");
  } finally {
    setUploading(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }
};
const fromRegion = location?.state?.source === "region"; // or however you know

const draft = getProfileDraft();

const formik = useFormik({
  initialValues: {
    firstName: draft.first_name || "",
    middleName: draft.middle_name || "",
    lastName: draft.last_name || "",
    phone: draft.phone_number || "",
     avatar: draft.profile_picture || "",  // ✅ add avatar
    dob: draft.dob || "",
    adminType: draft.administrator_type || "",
    // adminDocumentUrl: draft.admin_document_url || "",

  },
  // validate: (v) => {
  //   const e = {};
  //   if (!v.firstName) e.firstName = t("registerValidation.firstNameRequired");
  //   if (!v.lastName) e.lastName = t("registerValidation.lastNameRequired");
  //   if (!v.phone) e.phone = t("registerValidation.phoneRequired");
  //   else if (!/^\d+$/.test(v.phone)) e.phone = t("registerValidation.phoneDigitsOnly");
  //   if (!v.avatar) e.avatar = t("registerValidation.avatarRequired");
  //   if (!v.dob) e.dob = t("registerValidation.dobRequired");
  //   if (!v.adminType) e.adminType = t("registerValidation.adminTypeRequired");
  

  //   return e;
  // },
  validate: (v) => {
const e = {};
if (!v.firstName) e.firstName = "registerValidation.firstNameRequired";
if (!v.lastName) e.lastName = "registerValidation.lastNameRequired";
if (!v.phone) e.phone = "registerValidation.phoneRequired";
if (!v.avatar) e.avatar = "registerValidation.avatarRequired";
if (!v.dob) e.dob = "registerValidation.dobRequired";
if (!v.adminType) e.adminType = "registerValidation.adminTypeRequired";
return e;
},
  onSubmit: async (values) => {
    try {
      setSaving(true);

      setProfileDraft({
        first_name: values.firstName,
        middle_name: values.middleName,
        last_name: values.lastName,
        phone_number: values.phone,
profile_picture: values.avatar, 
        dob: values.dob,
        administrator_type: values.adminType,
        admin_document_url: values.adminDocumentUrl,
      });
  setTimeout(() => {
    navigate("/company-details", { state: { adminType: values.adminType } });
    setSaving(false); // stop loader after navigation
  }, 1000);
    } catch (err) {
      toast.error(t("saveDraftFailed"));
    }
  },
});



React.useEffect(() => {
  if (draft.profile_picture) {
    setAvatarPreview(draft.profile_picture);
  } else {
    setAvatarPreview(dummy);   // force dummy on first load
  }

  if (draft.admin_document_url) {
    const parts = draft.admin_document_url.split("/");
    setDocFileName(parts[parts.length - 1]);
    formik.setFieldValue("adminDocumentUrl", draft.admin_document_url);
  }
}, []);
  // Upload legal document (PDF/DOC/DOCX) and set URL in formik
  const uploadAdminDocToServer = async (file) => {
    const form = new FormData();
    // Backend expects field name 'pdf' per provided contract
    form.append("pdf", file);

    const res = await fetch(`${BASE_URL}/upload/pdf`, {
      method: "POST",
      body: form,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || t("uploadFailed"));
    return data?.data?.url || data?.url || data?.path || "";
  };

  const handleDocFileChange = async (file) => {
  // ✅ 1. If user clicks the cross icon (file = null)
  if (file === null) {
    setDocFileName("");
    formik.setFieldValue("adminDocumentUrl", "");
    return;
  }

  // ✅ 2. Proceed only if a real file is selected
  // Automatically detect file type
  const type = file.type.startsWith("image/")
    ? "image"
    : file.type === "application/pdf"
    ? "pdf"
    : null;

  if (!type) {
    toast.error(t("invalidFileType"));
    return;
  }

  try {
    setUploadingDoc(true);
    setDocFileName(file.name);

    // Build FormData
    const form = new FormData();
    form.append(type, file);

    // Select correct endpoint
    const endpoint = type === "image" ? "/upload/image" : "/upload/pdf";

    const res = await fetch(`${BASE_URL}${endpoint}`, {
      method: "POST",
      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || t("uploadFailed"));

    const uploadedUrl = data?.data?.url || data?.url || data?.path || "";

    // Save URL to Formik
    formik.setFieldValue("adminDocumentUrl", uploadedUrl);
    toast.success(t(type === "image" ? "imageUploadedSuccess" : "pdfUploadedSuccess"));
  } catch (err) {
    toast.error(err.message || t("uploadDocumentFailed"));
    formik.setFieldValue("adminDocumentUrl", "");
    setDocFileName("");
  } finally {
    setUploadingDoc(false);
  }
};


const [showCamera, setShowCamera] = React.useState(false);
const webcamRef = React.useRef(null);
const [capturedImage, setCapturedImage] = React.useState(null);
const [takingPhoto, setTakingPhoto] = React.useState(false);
const openCamera = (target = "avatar") => {
setCameraTarget(target);
setCapturedImage(null);
setShowCamera(true);
};


const capturePhoto = async () => {
  if (!webcamRef.current) return;

  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) {
    toast.error("Failed to capture image");
    return;
  }

  setCapturedImage(imageSrc);
  setTakingPhoto(true);

  try {
    // convert base64 → file
    const res = await fetch(imageSrc);
    const blob = await res.blob();
    const file = new File([blob], "camera.jpg", { type: "image/jpeg" });

    const formData = new FormData();
    formData.append("image", file);

    // use direct fetch like gallery upload
    const uploadRes = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: formData,
    });

    const result = await uploadRes.json();

    if (!uploadRes.ok || !result.data?.url) {
      throw new Error(result.message || "Upload failed");
    }

    const imageUrl = result.data.url;
    // setAvatarPreview(imageUrl);
    // formik.setFieldValue("avatar", imageUrl);
    if (cameraTarget === "avatar") {
setAvatarPreview(imageUrl);
formik.setFieldValue("avatar", imageUrl);
} else if (cameraTarget === "nationalId") {
formik.setFieldValue("adminDocumentUrl", imageUrl);
setDocFileName("camera-id.jpg");
}
    toast.success("Photo captured and uploaded");
    setShowCamera(false);

  } catch (err) {
    toast.error("Failed to upload photo");
  } finally {
    setTakingPhoto(false);
  }
};

const [docAnchorEl, setDocAnchorEl] = React.useState(null);
const openDocMenu = Boolean(docAnchorEl);
const openDocOptions = (e) => setDocAnchorEl(e.currentTarget);
const closeDocOptions = () => setDocAnchorEl(null);

const takeNationalIdPhoto = () => {
  closeDocOptions();
  openCamera("nationalId");
};

const pickNationalIdFromGallery = () => {
  closeDocOptions();
  document.getElementById("national-id-input")?.click();
};

const fileExt = docFileName?.split(".").pop()?.toLowerCase();

const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExt);
const isPdf = fileExt === "pdf";
const dobRef = useRef(null);

  return (
    <Box sx={{ py: isMobile ? 5 : 8, px: 2, mt: isMobile ? 2 : 0 }}>
      {/* <Toaster /> */}
      <Box sx={{ display: "flex", justifyContent: "center", minHeight: "100vh", alignItems: "center" }}>
        <BaseCard maxWidth={isMobile ? "100%" : isTablet ? "67%" : isLaptop ? "38%" : "43%"}>
         

           <Box sx={{ display: "flex", justifyContent: "flex-start",  mb: 3 }}>
         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ width: 25, height:25, borderRadius: "50%", backgroundColor: theme.palette.primary.main, color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>1</Box>
            <Box sx={{ width:isMobile?35: 95, height: 2, backgroundColor: "#091E4224" }} />
            <Box sx={{ width: 25, height:25,borderRadius: "50%", backgroundColor: "#ffffff", color: "#BCBFC2", border:"2px solid #091E4224",display: "flex", justifyContent: "center", alignItems: "center" }}>2</Box>
           <Box sx={{ width:isMobile?35:95, height: 2, backgroundColor: "#091E4224" }} />
           <Box sx={{ width: 25, height:25, borderRadius: "50%", backgroundColor: "#ffffff", color: "#BCBFC2",border:"2px solid  #091E4224", display: "flex", justifyContent: "center", alignItems: "center" }}>3</Box>
                      <Box sx={{ width:isMobile?35:95, height: 2, backgroundColor: "#091E4224" }} />
           <Box sx={{ width: 25, height:25, borderRadius: "50%", backgroundColor: "#ffffff", color: "#BCBFC2",border:"2px solid  #091E4224", display: "flex", justifyContent: "center", alignItems: "center" }}>4</Box>             
          </Box>
        </Box>


          <CustomText sx={{ ...textStyles.h4, color: theme.palette.tertiary.main, textAlign: "left", fontSize: "26px" }}>
            {t("createProfileTitle")}
          </CustomText>
          <CustomText sx={{ ...textStyles.body5, color: theme.palette.text.primary, pt: 0.7, textAlign: "left" }}>
            {t("createProfileSubtitle")}
          </CustomText>

          {/* Form */}
          <form onSubmit={formik.handleSubmit}>
         
<Box sx={{ mb: 2, mt: 2 }}>
  <label style={{ color: "#626F86", fontSize: "15px" }}>
    {t("profilePicture")}<span style={{ color: "red" }}>*</span>
  </label>

  <Box sx={{ mt: 2, display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
    <Box
      sx={{
        position: "relative",
        width: 150,
        height: 150,
        borderRadius: "50%",
        // border: "2px dashed #091E4224",
         border: formik.errors.avatar && formik.touched.avatar
      ? "2px dashed red"
      : "2px dashed #091E4224",
        display: "grid",
        placeItems: "center",
        cursor: uploading ? "not-allowed" : "pointer",
      }}
      onClick={(e) => {
        if (!uploading) {
          e.stopPropagation();
          handleOpenOptions(e);
        }
      }}
      title={uploading ? t("uploading") : t("clickToUpload")}
    >
       <img
           crossOrigin="anonymous"
      src={avatarPreview || dummy}
      // alt="Profile Preview"
      style={{
        width: "120px",
        height: "120px",
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />

  

      <IconButton
  size="small"
  sx={{
    fontSize:"14px",
    position: "absolute",
    top:1,
    right: 1,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    boxShadow: 1,
    "&:hover": { backgroundColor: "#f0f0f0" },
  }}
  onClick={(e) => {
    e.stopPropagation();
    handleOpenOptions(e);
  }}
>
  <AddIcon fontSize="small" />
</IconButton>


      {uploading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            backdropFilter: "blur(1px)",
            borderRadius: "50%",
          }}
        >
          <CircularProgress size={28} />
        </Box>
      )}
    </Box>

    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      hidden
      onChange={handleFileChange}
    />
  </Box>

  {formik.errors.avatar && (
    <Box sx={{ fontSize: 12, color: "red", mt: 0.5, display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
    {t(formik.errors.avatar)}
    </Box>
  )}
</Box>
<Menu
  anchorEl={anchorEl}
  open={openOptions}
  onClose={handleCloseOptions}
>
  <MenuItem onClick={handleSelectCamera} sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}>
 {t("takePhoto")}
  </MenuItem>

  <MenuItem onClick={handleSelectGallery}  sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}>
   {t("chooseFromGallery")}
  </MenuItem>
</Menu>

           <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 1, mb: 1, mt: 1 }}>
              <Box sx={{ flex: 1 }}>
                <label style={{ color: "#626F86", fontSize: 14 }}>{t("firstName")} <span style={{ color: "red" }}>*</span></label>
                <input
                  className="project_input"
          
                  name="firstName"
  value={formik.values.firstName}
  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14 }}
                />
                {formik.touched.firstName && formik.errors.firstName && (
                  <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.firstName)}</Box>
                )}
              </Box>
              <Box sx={{ flex: 1 }}>
                <label style={{color:"#626F86",fontSize:"14px"}}>{t("middleName") || "Middle Name"}</label>
                <input
                  className="project_input"
                  name="middleName"
                  value={formik.values.middleName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14 }}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                 <label style={{color:"#626F86",fontSize:"14px"}}>{t("lastName")} <span style={{ color: "red" }}>*</span></label>
                <input
                  className="project_input"
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{ height: 38, borderRadius: 6, width: "100%", marginTop: 7, fontSize: 14 }}
                />
                {formik.touched.lastName && formik.errors.lastName && (
                  <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.lastName)}</Box>
                )}
              </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 1, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <label style={{ color: "#626F86", fontSize: 14 }}>{t("dateOfBirth")} <span style={{ color: "red" }}>*</span></label>
     
        <input
  className="project_input"
  type="date"
  name="dob"
    ref={dobRef}
    onClick={() => dobRef.current?.showPicker()} 
  value={formik.values.dob}
  onChange={(e) => {
    const val = e.target.value;

    const parts = val.split("-");
    if (parts[0] && parts[0].length > 4) {
      parts[0] = parts[0].slice(0, 4);
    }
    const cleanVal = parts.join("-");

    // ----------- AGE VALIDATION (Must be ≥ 18) -----------
    const selectedDate = new Date(cleanVal);
    const today = new Date();

    if (cleanVal) {
      const ageDiff = today.getFullYear() - selectedDate.getFullYear();
      const monthDiff = today.getMonth() - selectedDate.getMonth();
      const dayDiff = today.getDate() - selectedDate.getDate();

      let age = ageDiff;
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--; // adjust age for month/day not reached
      }

      if (age < 18) {
        toast.error(t("age"));
        return; // STOP submitting invalid dob
      }
    }

    // If valid → set value in Formik
    formik.setFieldValue("dob", cleanVal);
  }}
  onBlur={formik.handleBlur}
  style={{
    height: 38,
    borderRadius: 6,
    width: "100%",
    marginTop: 7,
    fontSize: 14,
  }}
/>

                {formik.touched.dob && formik.errors.dob && (
                  <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.dob)}</Box>
                )}
              </Box>
              <Box sx={{ flex: 1 }}>
                <label style={{ color: "#626F86", fontSize: 14 }}>{t("administratorType")} <span style={{ color: "red" }}>*</span></label>
            <select
  className="project_input"
  name="adminType"
  value={formik.values.adminType}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
  style={{
    height: 38,
    borderRadius: 6,
    width: "100%",
    marginTop: 7,
    fontSize: 14,
    paddingRight: "28px",      // ✅ add space for arrow
    appearance: "none",         // ✅ normalize styling
    WebkitAppearance: "none",   // Safari fix
    MozAppearance: "none",      // Firefox fix
    backgroundImage:
      "url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath fill='black' d='M1 1l5 5 5-5'/%3E%3C/svg%3E\")", // custom arrow
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",  // ✅ move arrow inward
    backgroundSize: "12px 8px",
  }}
>
  <option value="" disabled>{t("selectOption") || "Select option"}</option>
  <option value="individual">{t("individual") || "Individual"}</option>
  <option value="legal_entity">{t("legalEntity") || "Legal Entity"}</option>
</select>

                {formik.touched.adminType && formik.errors.adminType && (
                  <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.adminType)}</Box>
                )}
              </Box>
            </Box>

            {/* Phone */}
            <Box sx={{ mb: 2 }}>
              <label style={{ color: "#626F86", fontSize: 14, marginBottom: 7, display: "inline-block" }}>
                {t("phoneNumber")} <span style={{ color: "red" }}>*</span>
              </label>
              <Box
                sx={{
                  // border: "2px solid  #091E4224",
                        border: formik.errors.phone && formik.touched.phone ? "1px solid red" : "2px solid #091E4224", // Conditionally apply red border

                  borderRadius: "6px",
                  "& .form-control": {
                    border: "none !important",
                    outline: "none !important",
                    boxShadow: "none !important",
                    width: "100%",
                    height: "40px",
                    fontSize: "14px",
                    paddingLeft: "48px",
                    borderRadius: "6px",
                    fontFamily: "Poppins, sans-serif !important",
                  },
                  "& .flag-dropdown": {
                    border: "none !important",
                    borderRight: "1px solid #ccc !important",
                    backgroundColor: "#f9f9f9",
                    borderTopLeftRadius: "6px",
                    borderBottomLeftRadius: "6px",
                  },
                }}
              >
                <PhoneInput
                  country={"us"}
                  value={formik.values.phone}
                  onChange={(value) => formik.setFieldValue("phone", value)}
                  inputProps={{ name: "phone", required: true }}
                  containerClass="react-tel-input"
                  inputClass="form-control"
                  buttonClass="flag-dropdown"
  countryCodeEditable={false}    
                />
              </Box>
              {formik.errors.phone && <Box sx={{ fontSize: 12, color: "red", mt: 0.5 }}>{t(formik.errors.phone)}</Box>}
          
            </Box>

            {/* Admin Legal Document */}
            {/* <DocumentUpload
              label= {t("nationalId.label")}
              // required={formik.values.adminType === 'legal_entity'}
              onFileSelect={handleDocFileChange}
              fileName={docFileName}
              isUploading={uploadingDoc}
              // error={formik.errors.adminDocumentUrl && formik.values.adminType === 'legal_entity' ? formik.errors.adminDocumentUrl : null}
              accept="image/*,.pdf,application/pdf"
                  disabled={uploadingDoc}
                    fileIcon={
    isImage ? imageicon : isPdf ? document1 : null
  }
            /> */}
            <Box onClick={(e) => {
e.stopPropagation(); // 🚫 stop DocumentUpload click
e.preventDefault();
openDocOptions(e);
}}>
<DocumentUpload
label={t("nationalId.label")}
onFileSelect={handleDocFileChange}
fileName={docFileName}
isUploading={uploadingDoc}
accept="image/*,.pdf"
disabled={uploadingDoc}
fileIcon={isImage ? imageicon : isPdf ? document1 : null}
/>
</Box>
<input
id="national-id-input"
type="file"
accept="image/*,.pdf"
hidden
onChange={(e) => {
const file = e.target.files?.[0];
if (file) handleDocFileChange(file);
e.target.value = ""; // allow re-select same file
}}
/>
<Menu anchorEl={docAnchorEl} open={openDocMenu} onClose={closeDocOptions}>
<MenuItem onClick={takeNationalIdPhoto} 
sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}>
{t("takePhoto")}
</MenuItem>
<MenuItem onClick={pickNationalIdFromGallery}
sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}>
{t("chooseFromGallery")}
</MenuItem>
</Menu>

            {/* Avatar */}
                               <Box sx={{ display: "flex",alignItems:"center", justifyContent: "flex-end",mt:2,gap: 2 }}>
       
   
            <CustomButton
              label={
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                  {(saving) && <CircularProgress size={18} sx={{ color: "#fff" } }/>}
                  {t("next")}
                </Box>
              }
                size="medium"
              type="submit"
              disabled={saving}
            
                                 sx={{py:1,px:6,}}

            />
            </Box>
          </form>
        </BaseCard>
      </Box>
{showCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1300,
      p: 2,
    }}
  >
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: 600,
      }}
    >
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        {!capturedImage ? (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode: "user", width: 600, height: 450 }}
            style={{
              borderRadius: "12px",
              width: "100%",
              maxWidth: "600px",
              objectFit: "cover",
              border: "2px solid #E0E0E0",
            }}
          />
        ) : (
          <img
            src={capturedImage}
            alt="Captured"
            style={{
              borderRadius: "12px",
              width: "100%",
              maxWidth: "600px",
              border: "2px solid #E0E0E0",
            }}
          />
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mt: 3,
          width: "100%",
        }}
      >
        {!capturedImage ? (
          <CustomButton
           label={takingPhoto ? t("uploading") : t("capture")}
            onClick={capturePhoto}
            disabled={takingPhoto}
            sx={{
              flex: 1,
              py: 1.2,
              borderRadius: "8px",
            }}
          />
        ) : (
          <CustomButton
            label={t("retake")}
            onClick={() => setCapturedImage(null)}
            sx={{
              flex: 1,
              py: 1.2,
              borderRadius: "8px",
            }}
          />
        )}
        <CustomButton
        label={t("close")}

          onClick={() => setShowCamera(false)}
          sx={{
            flex: 1,
            py: 1.2,
            borderRadius: "8px",
            backgroundColor: "#E0E0E0",
            color: "#333",
            "&:hover": { backgroundColor: "#D5D5D5" },
          }}
        />
      </Box>
    </Box>
  </Box>
)}
    </Box>
  );
};

export default CreateProfile;







































